import { createSlice } from '@reduxjs/toolkit';

export const saveDataSlice = createSlice({
  name: 'saveData',
  initialState: {
    targetAssets: {},
    general: {},
    directionalIndicator: [],
    nonDirectionalIndicator: [],
    bands: [],
    trend: [],
    timeManagement: {},
  },
  reducers: {
    updateTargetAssets: (state, action) => {
      state.targetAssets = action.payload;
    },
    updateGeneral: (state, action) => {
      state.general = action.payload;
    },
    updateDirectionalData: (state, action) => {
      state.directionalIndicator = action.payload;
    },
    updateNonDirectionalData: (state, action) => {
      state.nonDirectionalIndicator = action.payload;
    },
    updateBands: (state, action) => {
      state.bands = action.payload;
    },
    updateTrend: (state, action) => {
      state.trend = action.payload;
    },
    updateTimeManagement: (state, action) => {
      state.timeManagement = action.payload;
    },
  },
});

export const {
  updateDirectionalData,
  updateBands,
  updateGeneral,
  updateTimeManagement,
  updateNonDirectionalData,
  updateTrend,
  updateTargetAssets,
  updateNcbData,
} = saveDataSlice.actions;

export default saveDataSlice.reducer;
